export function setVisitorsLoading (state, loading = false) {
  state.visitorsLoading = loading
}

export function setOrdersLoading (state, loading = false) {
  state.ordersLoading = loading
}

export function setOferteLoading (state, loading = false) {
  state.oferteLoading = loading
}

export function setOferteWhatsappLoading (state, loading = false) {
  state.oferteWhatsappLoading = loading
}

export function setVisitors (state, { visitors, online, today }) {
  state.visitors = visitors
  state.visitors_online = online
  state.visitors_today = today
}

export function setOrders (state, { orders, orders_today, orders_year }) {
  state.orders = orders
  state.orders_today = orders_today
  state.orders_year = orders_year
}

export function setOferte (state, { oferte, oferte_today, oferte_year }) {
  state.oferte = oferte
  state.oferte_today = oferte_today
  state.oferte_year = oferte_year
}

export function setOferteWhatsapp (state, { oferte_wa, oferte_wa_today, oferte_wa_year }) {
  state.oferte_wa = oferte_wa
  state.oferte_wa_today = oferte_wa_today
  state.oferte_wa_year = oferte_wa_year
}